import { Button, Modal, Select } from "antd";
import { qaTypeButtons } from "../../constant";
import { chunkArray } from "../../utils/spliter";
import { useEffect, useState } from "react";

const SelectAuditType = ({ open, handleCancel, handleSubmit, OnSelect, QATYPE }) => {
  const buttonRows = chunkArray(qaTypeButtons, 2);
  const [tempType, setTempType] = useState(QATYPE);

  useEffect(() => {
    setTempType(QATYPE);
  }, [QATYPE]);

  return (
    <Modal
      title={
        <div className="container-fluid d-flex flex-column align-items-center text-center">
          <div className="d-flex justify-content-start flex-column w-100 mb-2">
            <div className="d-flex justify-content-center align-items-center assing-icon-css">
              <i className="bi bi-people icon"></i>
            </div>
          </div>
        </div>
      }
      open={open}
      onCancel={handleCancel}
      footer={
        <div className="assign-bottom-btn-css">
          <Button key="cancel" onClick={handleCancel} className="footer-btn-css">
            Cancel
          </Button>
          <Button key="confirm" onClick={() => handleSubmit(tempType)} className="footer-btn-1-css">
            Confirm
          </Button>
        </div>
      }
      width={750}
    >
      <div className="container-fluid">
        <div className="d-flex flex-column mt-2">
          <p className="text-css">Select Audit Type (Single Select)</p>

          {/* Dynamically render 2 buttons per row */}
          {buttonRows.map((row, rowIndex) => (
            <div
              key={`row-${rowIndex}`}
              style={{
                display: "flex",
                gap: "8px",
                marginTop: rowIndex === 0 ? "20px" : "10px",
              }}
            >
              {row.map((btn) => (
                <Button
                  key={btn.id}
                  onClick={() => setTempType(btn.id)}
                  style={{
                    flex: 1,
                    background: tempType === btn.id ? "#052659" : "transparent",
                    color: tempType === btn.id ? "#FFFFFF" : "#000",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  {btn.label}
                </Button>
              ))}
            </div>
          ))}

          {/* <p className="text-css mt-4">Select QA</p>
          <div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
            <Select
              showSearch
              className="select-QA"
              placeholder="Search by name, phone number, or keywords"
              optionFilterProp="label"
              onChange={onChange}
              onSearch={onSearch}
              options={qaList}
            />
          </div> */}
        </div>
      </div>
    </Modal>
  );
};

export default SelectAuditType;
